import React from 'react';
import PropTypes from 'prop-types';
function MenuIcon({ width, height, color }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <desc>Created with sketchtool.</desc>
      <g
        id="🌈-Style-"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Icons"
          transform="translate(-944.000000, -163.000000)"
          fill={color}
        >
          <g id="Colors-Copy" transform="translate(22.000000, 20.000000)">
            <path
              d="M924.990631,155 C925.54809,155 926,155.443353 926,156.009369 L926,157.990631 C926,158.54809 925.556647,159 924.990631,159 L923.009369,159 C922.45191,159 922,158.556647 922,157.990631 L922,156.009369 C922,155.45191 922.443353,155 923.009369,155 L924.990631,155 Z M930.990631,155 C931.54809,155 932,155.443353 932,156.009369 L932,157.990631 C932,158.54809 931.556647,159 930.990631,159 L929.009369,159 C928.45191,159 928,158.556647 928,157.990631 L928,156.009369 C928,155.45191 928.443353,155 929.009369,155 L930.990631,155 Z M936.990631,155 C937.54809,155 938,155.443353 938,156.009369 L938,157.990631 C938,158.54809 937.556647,159 936.990631,159 L935.009369,159 C934.45191,159 934,158.556647 934,157.990631 L934,156.009369 C934,155.45191 934.443353,155 935.009369,155 L936.990631,155 Z M924.990631,149 C925.54809,149 926,149.443353 926,150.009369 L926,151.990631 C926,152.54809 925.556647,153 924.990631,153 L923.009369,153 C922.45191,153 922,152.556647 922,151.990631 L922,150.009369 C922,149.45191 922.443353,149 923.009369,149 L924.990631,149 Z M930.990631,149 C931.54809,149 932,149.443353 932,150.009369 L932,151.990631 C932,152.54809 931.556647,153 930.990631,153 L929.009369,153 C928.45191,153 928,152.556647 928,151.990631 L928,150.009369 C928,149.45191 928.443353,149 929.009369,149 L930.990631,149 Z M936.990631,149 C937.54809,149 938,149.443353 938,150.009369 L938,151.990631 C938,152.54809 937.556647,153 936.990631,153 L935.009369,153 C934.45191,153 934,152.556647 934,151.990631 L934,150.009369 C934,149.45191 934.443353,149 935.009369,149 L936.990631,149 Z M924.990631,143 C925.54809,143 926,143.443353 926,144.009369 L926,145.990631 C926,146.54809 925.556647,147 924.990631,147 L923.009369,147 C922.45191,147 922,146.556647 922,145.990631 L922,144.009369 C922,143.45191 922.443353,143 923.009369,143 L924.990631,143 Z M930.990631,143 C931.54809,143 932,143.443353 932,144.009369 L932,145.990631 C932,146.54809 931.556647,147 930.990631,147 L929.009369,147 C928.45191,147 928,146.556647 928,145.990631 L928,144.009369 C928,143.45191 928.443353,143 929.009369,143 L930.990631,143 Z M936.990631,143 C937.54809,143 938,143.443353 938,144.009369 L938,145.990631 C938,146.54809 937.556647,147 936.990631,147 L935.009369,147 C934.45191,147 934,146.556647 934,145.990631 L934,144.009369 C934,143.45191 934.443353,143 935.009369,143 L936.990631,143 Z"
              id="ic_menu_apps_all"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

MenuIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string
};

MenuIcon.defaultProps = {
  width: '16px',
  height: '16px',
  color: '#0B0E12'
};

export default MenuIcon;
